import * as React from "react";
import { action } from "mobx";
import { observer, inject } from "mobx-react";
import * as UiStore from "../States/AreaUiInfo";

export interface IShowAreaAsideButtonProps {
	id?: string;
	disabled?: boolean;
	testId?: string;
	testName?: string;
	areaUiInfo?: UiStore.AreaUiInfoImpl;
	title: string;
}

@inject('areaUiInfo')
@observer
export class ShowAreaAsideButton extends React.Component<IShowAreaAsideButtonProps, {}> {

	@action onClick = () => {
		this.props.areaUiInfo.isCollapsed = !this.props.areaUiInfo.isCollapsed;
	}

	render() {
		let className = this.props.areaUiInfo.isCollapsed ? "button" : "button is--button-highlight";
		return <button id={this.props.id} className={className} disabled={this.props.disabled} onClick={this.onClick} data-test-id={this.props.testId} data-test-name={this.props.testName} title={this.props.title}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M30,6V26H2V6H30m2-2H0V28H32V4h0Z" />
					<rect x="4" y="8" width="8" height="16" />
				</svg>
			</i>
		</button>;
	}

}
